<template>
  <div>
    <el-card style="margin-bottom: 25px;border: none;box-shadow: none;"
      :class="isShow ? 'show_card' : 'show_card header-border'">
      <div slot="header" style="display: flex; justify-content:space-between;cursor: pointer" @click="changeShow">
        <span style="font-weight: bold;font-size: 14px;color: #636569">信息解释</span>
        <i class="el-icon-arrow-up" v-show="isShow"
          style="cursor: pointer;color: #1e6cb0;font-weight: bold;font-size: 14px;" title="展开介绍">折叠</i>
        <i class="el-icon-arrow-down" v-show="!isShow"
          style="cursor: pointer;color: #1e6cb0;font-weight: bold;font-size: 14px;" title="折叠介绍">展开</i>
      </div>
      <el-descriptions v-show="isShow" style="margin-bottom: 0;font-size: 13px!important;" border :column="3"
        :labelStyle="{width:'126px'}">
        <el-descriptions-item label="文件自动同步" :span="3">
          该数据从share服务器获取，每3小时同步一次
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
    <div style="margin-bottom: 20px;margin-top: 30px">
      <el-button size="small" v-if="['ADMIN','MANAGER'].includes(role)" type="success"
        @click="handleEdit()">批量绑定负责人</el-button>
     <el-button size="small" v-if="['ADMIN'].includes(role)" type="success"
        @click="handleAddEdit()" icon="el-icon-plus">添加</el-button>
    </div>
    <el-tabs v-model="activeTab" @tab-click="changeTab">
      <el-tab-pane v-for="(item,tabIndex) in data" :label="item.label" :name="item.name" :key="tabIndex">
        <span slot="label" v-if="item.showBadge">
          <el-badge style="margin-top: 10px;margin-bottom: 10px" :value="pageTotal[item.name] === 0 ? '':pageTotal[item.name]"
            :max="99">{{item.label}}</el-badge>
        </span>
      </el-tab-pane>
    </el-tabs>
    <w-table :columns="columns" :table-data="tableData" @rowSelection="rowSelection($event)"
      v-if="activeTab !== '更新日志'" @getTableSearchSortCon="(...event) => { getTableSearchSortCon(event) }"
      :isPagination="true" ref="wMyTable" :page="page" @pageChange="handlePagePagination"
      :table-col-check="{ isShow: true, name: 'Company' + activeTab }"
      :isShowRowSelection="true" :key="activeTab">
      <template slot="companyInvoiceStatus" slot-scope="{text, record,index}">
        <span v-if="['ADMIN', 'MANAGER'].includes(role)">
          <el-switch v-model="tableData[index]['companyStatus']" @change="handleUpdate(record, !text)"
            active-text="是" inactive-text="否" active-color="#13ce66" inactive-color="#ff4949">
          </el-switch>
        </span>
        <span v-else class="status-tag-container">
          <el-tag v-if=!text type="success">是</el-tag>
          <el-tag v-else-if=text type="danger">否</el-tag>
          <el-tag v-else type="warning">无权限</el-tag>
        </span>
      </template>
      <template slot="threePartyQuotationStatus" slot-scope="{text, record,index}">
        <span v-if="['ADMIN', 'MANAGER'].includes(role)">
          <el-switch v-model="tableData[index]['threePartyQuotationStatus']"
            @change="handleUpdateThreePartyStatus(record, !text)" active-text="支持" inactive-text="不支持"
            active-color="#13ce66" inactive-color="#ff4949">
          </el-switch>
        </span>
        <span v-else class="status-tag-container">
          <el-tag v-if="text===true" type="success">支持</el-tag>
          <el-tag v-else-if="text===false" type="danger">不支持</el-tag>
          <el-tag v-else type="warning">无权限</el-tag>
        </span>
      </template>
      <template slot="operation" slot-scope="{text,record}">
        <el-button size="mini" v-if="['ADMIN', 'MANAGER','BUSINESS_COMMERCIAL'].includes(role)" type="warning" @click="handleAddEdit(record)"
          icon="el-icon-edit">编辑</el-button>
        <el-button size="mini" type="primary" v-if="['ADMIN','MANAGER'].includes(role)"
          @click="handleEdit(record)">修改负责人</el-button>
        <el-button size="mini" type="primary" color="#ffffff" v-if="record.appendix" icon="el-icon-download"
          @click="download(record)">下载公司资料</el-button>
        <el-button size="mini" type="success" icon="el-icon-document-copy"
          @click="copyRecord(record)">复制公司信息</el-button>
      </template>
      <template slot="copyInfoData" slot-scope="{text, record,index}">
        <div v-if="text">
          <span>{{ text }}</span>
          <el-tooltip content="复制">
            <a-icon type="copy" style="color: #3f9dfe" @click="copyData(text)" />
          </el-tooltip>
        </div>
      </template>
      <template slot="companyAddress" slot-scope="{text,record,index,column}">
        <div style="display: flex;align-items: center">
          <w-ellipsis-and-look :text="text" :column="column"></w-ellipsis-and-look>
          <el-tooltip content="复制">
            <a-icon v-if="text" type="copy" style="color: #3f9dfe" @click="copyData(text)" />
          </el-tooltip>
        </div>
      </template>
      <template slot="depositBank" slot-scope="{text, record,index,column}">
        <div style="display: flex;align-items: center">
          <w-ellipsis-and-look :text="text" :column="column"></w-ellipsis-and-look>
          <el-tooltip content="复制">
            <a-icon v-if="text" type="copy" style="color: #3f9dfe" @click="copyData(text)" />
          </el-tooltip>
        </div>
      </template>
    </w-table>
    <el-timeline v-if="activeTab==='更新日志'">
      <el-timeline-item :color="item.size === 'large' ? '#409EFF': '#e4e7ed'" :size="item.size"
        :timestamp="item.updateTime" placement="top" v-for="(item,index) in logData" :key="index">
        <el-card>
          <h4 v-if="item['updateContent'] && item['updateContent'].length > 0">更新内容:</h4>
          <ul>
            <li class="logDetail" v-for="(itemInner,index) in item['updateContent']"><i
                class="iconfont icon-dian"></i>{{ itemInner }}
            </li>
          </ul>
        </el-card>
      </el-timeline-item>
    </el-timeline>
    <picture-loading v-if="loading"></picture-loading>
    <company-bind-charge v-if="showCharge" :show-dialog="showCharge" :select-detail="selectDetail"
      @submit="closeCharge">
    </company-bind-charge>
    <add-edit-company v-if="addEdit.showDialog" :show-dialog="addEdit.showDialog" :select-detail="addEdit.selectDetail" :type="addEdit.type" @submit="closeAddEdit"></add-edit-company>
  </div>
</template>

<script>
import { getCompanyPage, updateStatus, updateThreePartyStatus } from "@/api/dilivery/company";
import {company} from "@/utils/data/tableCol/company/company";
import AddEditCompany from "@/components/company/AddEditCompany.vue";
import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import CompanyBindCharge from "@/components/company/CompanyBindCharge.vue";
import {getDataInLocalStorage} from "@/utils/localStorage";
import {copyText} from "@/utils/windowsUtils";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import {getMethodLog} from "@/api/dilivery/method";
const baseURL = process.env.VUE_APP_BASE_API


export default {
  name: "Company",
  components: {PictureLoading, CompanyBindCharge, TableHeadNote, AddEditCompany},
  data() {
    return {
      tableData: [],
      selectable: [],
      searchConditionTag: [],
      sortConditionTag: [],
      page: { pageSize: 10, currentNum: 1, total: null },
      data: [
        { label: '全部', name: 'all', showBadge: false },
        { label: '可开票公司', name: '可开票公司', showBadge: false },
        { label: '不可开票公司', name: '不可开票公司', showBadge: false },
        { label: '三方报价', name: '三方报价', showBadge: false },
        { label: '更新日志', name: '更新日志', showBadge: false },
      ],
      sendData: {
        all: {},
        '可开票公司': { "query#companyInvoiceStatus.EQ": true },
        '不可开票公司': { "query#companyInvoiceStatus.EQ": false },
        '三方报价': { "query#threePartyQuotationStatus.EQ": true },
      },
      pageTotal: { all: 0, '可开票公司': 0, '不可开票公司': 0, '三方报价': 0, '更新日志': 0 },
      ids: [],
      role: '',
      activeTab: 'all',
      loading: true,
      logData: [],
      showCharge: false,
      selectDetail: {
        id: [],
        contractPrincipalUuid: '',
        invoicedPrincipalUuid: '',
      },
      addEdit: {
        showDialog: false,
        selectDetail: {},
        type: ''
      },
      selectType: {},
      isShow: true
    }
  },
  computed: {
    columns() {
      return JSON.parse(JSON.stringify(company([] || {}, this.role)))
    },
  },
  mounted() {
    this.getData()
  },
  created() {
    this.role = getDataInLocalStorage('role')
  },
  methods: {
    handleAddEdit(row) {
      if (row) {
        this.addEdit.selectDetail = { ...row }
        this.addEdit.type = 'edit'
      } else {
        this.addEdit.selectDetail = {}
        this.addEdit.type = 'add'
      }
      this.addEdit.showDialog = true
    },
    closeAddEdit() {
      this.addEdit.showDialog = false
      this.addEdit.selectDetail = {}
      this.addEdit.type = ''
      this.getData()
    },
    getLogData() {
      this.loading = true
      let params = { updateLogType: 'COMPANY_INFO' }
      getMethodLog(params).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.logData = res.data.map(item => ({ ...item, size: 'large' }))
        }
      }).catch(err => { this.loading = false })
    },
    handleUpdate(row, status) {
      updateStatus(row.id, status).then(res => {
        if (res.code === 200) {
          this.getData()
          this.$messageUi.success('修改公司开票状态成功')
        }
      }).catch(err => {})
    },
    changeShow() {
      this.isShow = !this.isShow
    },
    handleUpdateThreePartyStatus(row, status) {
      updateThreePartyStatus(row.id, status).then(res => {
        if (res.code === 200) {
          this.getData()
          this.$messageUi.success('修改公司三方报价状态成功')
        }
      }).catch(err => {})
    },
    async download(row) {
      try {
        let url = `${baseURL}/businessInformation/attachment/${row.id}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
        const elink = document.createElement('a')
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
    rowSelection(selectedRows) {
      this.ids = selectedRows.map(item => item.id)
    },
    getTableSearchSortCon(ConditionTag) {
      this.searchConditionTag = ConditionTag[0]
      this.sortConditionTag = ConditionTag[1]
      this.getData('search')
    },
    getData(searchFlag) {
      if (this.activeTab === '更新日志') return
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      }
      if (searchFlag) {
        params = { 'page.current': 1, 'page.size': 10 }
      }
      if (this.sortConditionTag && this.sortConditionTag.length > 0) {
        params["order"] = this.sortConditionTag.map(sortCondition => {
          return sortCondition.colName + "." + sortCondition.order;
        }).join(",");
      }
      let sendData = { ...this.sendData[this.activeTab] }
      if (this.searchConditionTag && this.searchConditionTag.length) {
        sendData = this.getSearch(sendData)
      }
      getCompanyPage(params, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records.map(item => ({
            ...item,
            companyStatus: !item['companyInvoiceStatus']
          }))
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
          this.$set(this.pageTotal, this.activeTab, parseInt(res.data.total))
        }
      }).catch(error => {
        this.loading = false
      })
    },
    getSearch(sendData) {
      
      this.searchConditionTag.forEach(item => {
        sendData["query#" + item.key + ".LIKE"] = item.value
      })
      return sendData
    },
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    changeTab() {
      if (this.activeTab !== '更新日志') {
        this.$nextTick(() => {
          this.tableData = []
          this.selectable = []
          this.searchConditionTag = []
          this.sortConditionTag = []
          this.page = { pageSize: 10, currentNum: 1, total: null }
          if (this.$refs.wMyTable) {
            this.$refs.wMyTable.selectedRowKeys = []
            this.$refs.wMyTable.searchConditionTag = []
          }
          this.getData()
        })
      } else {
        this.getLogData()
      }
    },
    computerNote(text) {
      if (text) {
        return text.length <= 4 ? text : text.substring(0, 4)
      }
      return ''
    },
    handleEdit(row) {
      this.selectDetail = {}
      if (row) {
        this.selectDetail.id = [row.id]
        this.selectDetail.contractPrincipalUuid = row.contractPrincipalUuid
        this.selectDetail.invoicedPrincipalUuid = row.invoicedPrincipalUuid
        this.showCharge = true
      } else {
        if (this.ids.length > 0) {
          this.selectDetail.id = this.ids
          this.showCharge = true
        } else {
          this.$messageUi.error('请勾选要批量绑定负责人的数据')
        }
      }
    },
    closeCharge(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() => {
        this.showCharge = false
      })
    },
    copyData(text) {
      copyText(text)
      this.$messageUi.success('复制成功')
    },
    copyRecord(row) {
      let text = `公司名称:${row.companyName}\n地址:${row.companyAddress}\n开户行:${row.depositBank}\n银行账号:${row.bankAccount}\n纳税人识别号:${row.taxpayerNumber}\n`
      copyText(text)
      this.$messageUi.success('复制成功')
    }
  }
}
</script>

<style scoped>

</style>
